import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Nav from "./components/Nav";
import ScrollToTop from "./hooks/scrollToTop";
//Components

import About from "./pages/About";
import Docs from "./pages/Docs";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Stacks from "./pages/Stacks";


function App() {
  return (
    <div className="App">
     
      <BrowserRouter>
        {<Nav/>}
        <ScrollToTop/>
        <Routes>
          <Route path="/" element ={<Home/>}/>
          <Route path="/about" element ={<About/>}/>
      
          <Route path="/docs" element ={<Docs/>}/>
          <Route path="/docs/stacks" element={<Stacks/>}/> 
          <Route path="/projects" element={<Projects/>}/>

        </Routes>
        {<Footer/>}
      </BrowserRouter>
    </div>
  );
}

export default App;
